export default __webpack_public_path__ + "static/media/adrien.fd9fdddb.png";